import { render, staticRenderFns } from "./ProfileRestrictionManageModal.vue?vue&type=template&id=2a594152"
import script from "./ProfileRestrictionManageModal.vue?vue&type=script&lang=js"
export * from "./ProfileRestrictionManageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports